module.exports = __webpack_public_path__ + "img/HQ-PA2W1CL.88556e52.jpg";